import { FormLayout } from 'components/common'
import { DynamicInputList } from 'components/common/dynamicInputList'
import {
  UseFormSetValue,
  FieldValues,
  FieldErrors,
  UseFormWatch,
} from 'react-hook-form'
import RmaReasonMapping from './rmaReasonMapping'

type Props = {
  setValue: UseFormSetValue<FieldValues>
  reason?: string[]
  condition?: string[]
  watch: UseFormWatch<FieldValues>
  errors: FieldErrors<FieldValues>
  conditionCodeMap: Record<any, string> | undefined
}

const RmaSection = ({
  setValue,
  reason,
  condition,
  watch,
  errors,
  conditionCodeMap,
}: Props) => {
  const watchedReasons = watch('rmaReasons') || []
  return (
    <>
      <h3 className="title">RMA Configuration</h3>
      <FormLayout>
        <div className="flex w-full gap-3">
          <aside className="w-full">
            {' '}
            <DynamicInputList
              label="Reason"
              name="rmaReasons"
              placeholder="Add RMA Reason"
              setValue={setValue}
              defaultValues={reason}
              errors={errors}
            />
            <RmaReasonMapping
              reasons={watchedReasons}
              defaultMap={conditionCodeMap}
              setValue={setValue}
              errors={errors}
            />
          </aside>
          <aside className="w-full">
            <DynamicInputList
              label="Conditions"
              name="rmaConditions"
              placeholder="Add RMA Condition"
              setValue={setValue}
              defaultValues={condition}
              errors={errors}
            />
          </aside>
        </div>
      </FormLayout>
    </>
  )
}

export default RmaSection
